module.exports = __webpack_public_path__ + "static/media/chto-vy-znayete-o-memakh.e2de943f.svg";